// extracted by mini-css-extract-plugin
module.exports = {"container":"snapshot_item__container__uf0gD","label":"snapshot_item__label__T4kYq","icon":"snapshot_item__icon__GfXAG"};